import React from 'react';

const LanguageToggle = ({ isHindi, toggleLanguage }) => {
  return (
    <button className="language-toggle" onClick={toggleLanguage}>
      {isHindi ? 'EN' : 'हि'}
    </button>
  );
};

export default LanguageToggle;